export const PRODUCER_ROUTE_NAMES = {
  PRODUCERPROFILEVIEW: 'producer-profile-view',
  CUSTOMLISTMANAGE: 'my-lists/:id',
  MYCUSTOMLISTS: 'my-lists',
  CUSTOMLISTITEMFORM: 'custom-list-item-form',
  /*ROUTE_NAME*/
};
